import {FC} from 'react'
import {crmType} from '../../../types/apps/AppsModel'
import {useIntl} from 'react-intl'

type Props = {
  crm: crmType
}

const CRMTitle: FC<Props> = ({crm}) => {
  const intl = useIntl()

  const map: Record<string, string> = {
    ONEC: 'APPS.1C.INFO',
    ROISTAT: 'APPS.ROISTAT.PROJECT',
  }

  return <>{intl.formatMessage({id: map[crm] ?? 'APPS.CRMDOMAIN'})}</>
}

export {CRMTitle}
